import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "content"]

  connect() {
    this.dialogTarget.addEventListener("click", (e) => {
      if (e.target === this.dialogTarget) this.dialogTarget.close()
    })

    // Turbo キャッシュ復元時にダイアログを閉じる
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  async open(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.previewUrl
    this.contentTarget.innerHTML = '<div class="flex justify-center py-12"><div class="bounce-loader"><div class="dot"></div><div class="dot"></div><div class="dot"></div><div class="dot"></div><div class="dot"></div></div></div>'
    this.dialogTarget.showModal()

    const response = await fetch(url)
    this.contentTarget.innerHTML = await response.text()
  }

  close() {
    this.dialogTarget.close()
  }
}
